// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__QPwCu","loader-spin":"loader_loader-spin__2vqrR","loaderContainer":"loader_loaderContainer__tA0bZ"};